import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// Newly added code starts
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
// Newly added code ends
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: ShopCentroFlyoutStyles;
}

export interface ShopCentroFlyoutStyles {
    widgetGridContainer?: GridContainerProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    parentGridWrapper?: InjectableCss;
}

export const shopCentroFlyoutStyles: ShopCentroFlyoutStyles = {
    parentGridWrapper: {
        css: css`
            position: relative;
        `,
    },
    widgetGridContainer: {
        css: css`
            position: relative;
            display: none;
            width: 260px;
            padding: 15px;
            border: 1px solid ${COLORS.border.light};
            box-shadow: 0px 8px 16px rgba(38, 37, 37, 0.24);
            background-color: ${COLORS.white};

            &.open-shop-centro-flyout {
                display: block;
                position: absolute;
                right: 24%;
                z-index: 1;
            }

            &:before, &:after {
                content: '';
                display: block;
                position: absolute;
                bottom: 100%;
                width: 0;
                height: 0;
              }
              &:before {
                right: 19px;
                border: 11px solid transparent;
                border-bottom-color: ${COLORS.border.light};
              }
              &:after {
                right: 20px;
                border: 10px solid transparent;
                border-bottom-color: ${COLORS.white};
              }
        `,
    },
    linkList1GridItem: {
        width: 12,
        css: css`
            display: block;
            padding: 0 15px;
        `,
    },
    linkList2GridItem: {
        width: 12,
        css: css`
        display: block;
            padding: 0 15px;
        `,
    },
    subscribeGridItem: {
        width: 12,
        css: css`
            padding: 0;
        `,
    },
};

const ShopCentroFlyout: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(shopCentroFlyoutStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.parentGridWrapper}>
            <GridContainer {...styles.widgetGridContainer} id="shop-centro-flyout">
            <GridItem {...styles.linkList1GridItem}>
                <StyledWrapper>
                    <Zone zoneName="LinkList1" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
                <StyledWrapper>
                    <Zone zoneName="LinkList2" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.subscribeGridItem}>
                <Zone zoneName="Subscribe" contentId={id} />
            </GridItem>
        </GridContainer>
        </StyledWrapper>
        
    );
};

const shopCentroFlyout: WidgetModule = {
    component: ShopCentroFlyout,
    definition: {
        group: "Header",
    },
};

export default shopCentroFlyout;
